import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forbidden',
  template: `<p>forbidden</p>`
})
export class ForbiddenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
